import React from 'react';
import './style.css';
import ContentHeading from '../../components/contentHeading/contentHeading';
import ContentHeadingButton from '../../components/contentHeading/contentHeadingButton';
import FlowsPreview from '../../components/flowsPreview/flowsPreview';
import { useNavigate } from 'react-router-dom';
import { useRef } from 'react';

const FlowsDetail = () => {
    const navigate = useNavigate();
    const containerRef = useRef(null); // Reference to the container element

    const handleGoBack = () => {
        navigate('/flows');
    };

    return (
        <div className='flows-detail-container'>
            <ContentHeading action={
                 <ContentHeadingButton handleContentHeadingButton={handleGoBack} buttonStyleClass="back-button" buttonName="Go Back" />
            } heading="Flow Detail: Welcome Series" />
            <FlowsPreview />

        </div>
    );
}; 

export { FlowsDetail };
